namespace appn.views.folders.edit {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        $('button').click(function() {
            (window as any).parent.folderSave = true;
        });
    }
}
